import { ApplicationRef, Component, NgZone, OnInit, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from './core/services/user.service';
import { MasterdataService } from '../app/core/services/masterdata.service';
import { LanguageService } from './core/services/language.service';
import { Router, RouterOutlet } from '@angular/router';
import { fadeAnimation } from './core/animations';
import { InfoScreenService } from './core/services/info-screen.service';
import { InfoScreenDto } from './core/models/info-screen.model';
import { SessionService } from '@evonik/ng-core';
import { first } from 'rxjs';
import { Location } from '@angular/common';
import { Colors } from '@evonik/evo';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    animations: [
        fadeAnimation
    ],
    standalone: false
})
export class AppComponent implements OnInit {
    private readonly translateService = inject(TranslateService);
    private readonly authService = inject(UserService);
    private readonly languageService = inject(LanguageService);
    private readonly masterDataService = inject(MasterdataService);
    private readonly infoScreenService = inject(InfoScreenService);
    private readonly userService = inject(UserService);
    private readonly auth = inject(SessionService);
    private readonly appRef = inject(ApplicationRef);
    private readonly location = inject(Location);
    private readonly router = inject(Router);
    private zone = inject(NgZone);


    loadingMasterData = false;

    startApp = false;
    isAppStable : boolean = false;

    showInfoScreen: boolean = false;
    infoScreens: Array<InfoScreenDto> = [];

    colors = Colors;

    ngOnInit(): void {
        this.translateService.setDefaultLang('en');
        this.translateService.addLangs(['en', 'de']);
        this.translateService.use(this.languageService.currentLanguage);

        this.masterDataService.loading.subscribe(loading => this.loadingMasterData = loading);

        this.infoScreenService.getAll().subscribe({
            next: (infoScreens) => {
                this.infoScreens = infoScreens ? infoScreens.filter(infoScreen => !infoScreen.isHidable) : [];
                if (this.infoScreens.length > 0) {
                    this.showInfoScreen = true;
                }
            },
            error: (error) => {
                console.error(error);
            }
        });

        this.auth.userDetails.subscribe(async ud => {
            if (ud.email != undefined) {
                //if user authenticated, get configuration
                try {
                    await this.userService.loadUser();
                } catch (error) {
                    console.log('an error occured when load user')
                }
            } 
        })  

        this.appRef.isStable
            .pipe(first(isStable => isStable))
            .subscribe((isStable) => {
                this.isAppStable = isStable;

                this.zone.run(() => {
                    // Now navigate to the current URL in the address bar or a default URL like '/'
                    const initialPath = this.location.path() || '/';
                    this.router.navigateByUrl(initialPath);
                });
        });
    }
    title = 'ans-ana3-fe';

    get masterData() {
        return this.masterDataService.masterData;
    }

    start() {
        this.startApp = true;
    }

    prepareRoute(outlet: RouterOutlet) {
        return outlet?.activatedRouteData['animation'];
    }

    isAuthorized(): boolean | undefined {
        return this.authService.hasANA3Auth();
    }

    setCloseInfoScreen(status: boolean) {
        this.showInfoScreen = !status;
    }
}
